import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { partnerStyled, usePartner, partnerValue, PartnerContent } from 'packages/smart-home-support/partner';
import { TechCoachCTA } from '../../components';
import { getAccentColor, getBreakpoint } from '../../utils';
import { Button, Heading2, TabContent } from '../../styles';
import { LinkId } from 'packages/smart-home-support/constants';

const breakpoint = getBreakpoint();

const s = {
  Button,
  Heading2,
  TechCoachCTAWrapper: styled.div`
    @media ${breakpoint} {
      margin-right: 50px;
      width: 50%;
    }
  `,
  Content: styled.div`
    line-height: 1.5;
    margin-top: 15px;
    margin-bottom: 26px;
  `,
  TabContent: styled(TabContent)`
    @media ${breakpoint} {
      display: flex;
      font-size: 20px;
    }
  `,
  Footnote: styled.div`
    margin-top: 35px;
    font-size: 16px;
    line-height: 1.5;
  `,
  FootnoteLink: styled(Link)`
    color: ${getAccentColor};
    text-decoration: none;
    font-weight: bold;
    ${partnerStyled.Sprint`
      color: #000;
      border-bottom-width: 1px;
      border-bottom-style: solid;
      padding-bottom: 7px;
      @media ${breakpoint} {
        border-bottom: none;
        padding-bottom: 0;
      }
    `}
  `,
};

const SupportTab: React.FC = () => {
  const [{ claimUrl, productName }] = usePartner();

  return (
    <s.TabContent>
      <s.TechCoachCTAWrapper>
        <TechCoachCTA chatLinkId={LinkId.DashboardGetHelpChat} callLinkId={LinkId.DashboardGetHelpCall} />
      </s.TechCoachCTAWrapper>
      <div>
        <s.Heading2>File a new claim</s.Heading2>
        <s.Content>
          <PartnerContent Sprint="Power surge failures? Device breakdowns? Life happens. When it does, we&rsquo;ve got your back.">
            Cracks? Spills? Power surges? Breakdowns? Life happens. When it does, we&rsquo;re here.
          </PartnerContent>
        </s.Content>
        <s.Button showLeavingIcon className="dashboard-support-claim" to={claimUrl} target="_blank">
          Start a claim now
        </s.Button>
        <s.Footnote>
          Claim coverage begins 30 days after enrollment in{' '}
          {partnerValue({ Sprint: `Sprint ${productName}` }, productName || '')}.{' '}
          <s.FootnoteLink to="/whats-covered">See a full list of what&rsquo;s covered</s.FootnoteLink>
        </s.Footnote>
      </div>
    </s.TabContent>
  );
};

export default SupportTab;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/tabs/SupportTab/SupportTab.tsx